import { createMuiTheme } from "@material-ui/core";
import { globalStyles } from "./globalStyles";

const theme = createMuiTheme({
    typography: {
        "fontFamily": `Inter, sans-serif`,
        "fontSize": 16,
        "letterSpacing": 'normal'
    },
    palette: {
        primary: {
            main: globalStyles.palette.brandPrimary.main,
        },
        brandGrey: {
            main: '#212529',
            light: '#D9D9D6'
        },
        brandBlack: {
            main: '#000A12'
        },
        brandBlue: {
          main: '#123274'
        },
        background: {
            default: '#fff'
        },
        text: {
            primary: '#000A12'
        }
    },
    link: {
        textDecorationStyle: 'none'
    }
});

theme.overrides = {
    MuiPaper: {
        elevation1: {
            boxShadow: 'none'
        }
    },
    MuiLink: {
        root: {
            color: theme.palette.primary.main,
            fontWeight: 500,
        }
    },
    MuiTouchRipple: {
        child: {
            backgroundColor: theme.palette.primary.main
        }
    },
    MuiButton: {
        contained: {
            backgroundColor: theme.palette.primary.main,
            border: `2px solid transparent`,
            color: 'white',
            borderRadius: 0,
            boxShadow: 'none',
            padding: '15px 30px',
            lineHeight: '1.2',
            textTransform: 'capitalize',
            '&:hover': {
                borderColor: theme.palette.primary.main,
                backgroundColor: 'white',
                color: theme.palette.primary.main,
                boxShadow: 'none',
            }
        }
    },
    MuiInput: {
        underline: {
            '&:before': {
                borderBottomColor: theme.palette.brandBlack.main,
            },
            '&:after': {
                borderBottomColor: theme.palette.primary.main,
            },
            '&:hover:not($disabled):before': {
                borderBottomColor: theme.palette.primary.main,
            },
        },
        root: {
            fontSize: theme.typography.fontSize
        }
    },
    MuiInputLabel: {
        animated: {
            fontSize: theme.typography.fontSize
        }
    },
    MuiTableCell: {
        head: {
            color: theme.palette.brandGrey.main,
            fontWeight: 500,
            fontSize: 20,
            borderBottom: `2px solid ${theme.palette.brandBlue.main}`,
        },
        root: {
            borderBottom: `1px solid ${theme.palette.brandBlue.main}`,
            padding: 13,
            height: 42
        }
    },
    MuiTableRow: {
        root: {
            '& > td:nth-child(1)': {
                width: '17%',
                minWidth: 100
            },
            '& > td:nth-child(2)': {
                width: '67%',
                fontWeight: 500,
            },
            '& > td:nth-child(3)': {
                width: '16%'
            }
        }
    },
    MuiMenuItem: {
        root: {
            fontSize: theme.typography.fontSize
        }
    }
};

export default theme;
